import { render } from "./headerx.vue?vue&type=template&id=72f526bd"
import script from "./headerx.vue?vue&type=script&lang=js"
export * from "./headerx.vue?vue&type=script&lang=js"

import "./headerx.vue?vue&type=style&index=0&id=72f526bd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__